import { createContext } from 'react';
const callManageContext = createContext<any>({});
export default callManageContext;